import userdata from './userdata';
import auth from './auth';

export default {
  ...auth,
  ...userdata,
};
